import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// منابع ترجمه
const resources = {
  en: {
    translation: {},
  },
  fa: {
    translation: {},
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // زبان پیش‌فرض
  fallbackLng: "en", // در صورت نبود ترجمه
  debug: true, // برای لاگ‌زدن هنگام توسعه

  interpolation: {
    escapeValue: false, // برای جلوگیری از مشکل XSS
  },
});

export default i18n;
